import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'vendors',
} as const satisfies Location
